import installQuasar from "./install-quasar.es.js";
import Plugin from "./plugins/lang/Lang.es.js";
import Plugin$1 from "./plugins/icon-set/IconSet.es.js";
const Quasar = {
  name: "Quasar",
  version: "2.17.4",
  install: installQuasar,
  // TODO: remove in Qv3 (should only be used through the plugin)
  // We provide a deprecated fallback here
  lang: Plugin,
  // TODO: remove in Qv3 (should only be used through the plugin)
  // We provide a deprecated fallback here
  iconSet: Plugin$1
};
export {
  Quasar as default
};
//# sourceMappingURL=vue-plugin.es.js.map
